<template>
  <div>
    <div v-if="object && !object.id">
      <b-tabs nav-class="sub-menu"
              content-class="pt-4"
              class="w-100"
              @activate-tab="tabChanged">
        <b-tab active :title="$t('quick_card')"></b-tab>
        <b-tab :title="$t('full_card')" ></b-tab>
        <b-tab :title="$t('representative_noun')" ></b-tab>
        <b-tab :title="$t('messengers')" ></b-tab>
      </b-tabs>
    </div>
    <div v-if="object && object.id">
      <b-tabs nav-class="sub-menu"
              content-class="pt-4"
              class="w-100"
              @activate-tab="tabSelected">
        <b-tab active :title="$t('general_info')"></b-tab>
        <b-tab :title="$t('passport_data')" ></b-tab>
        <b-tab :title="$t('representative_noun')" ></b-tab>
        <b-tab :title="$t('messengers')" ></b-tab>
<!--        <b-tab v-if="rights.includes('egisz_view')" :title="$t('egisz')" ></b-tab>-->
      </b-tabs>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, watch} from "vue"
import {useStore} from "vuex"

const props = defineProps({
  object: {
    type: Object
  },
  options: {},
})

const store = useStore()

const newPatientViews = ['quick_card', 'full_card', 'representative', 'messengers']
const views = ['general_info', 'passport_data', 'representative', 'messengers', 'egisz']

const representativePerson = computed(() => props.object.representative)
const rights = computed(() => store.state.auth.rights)

onMounted(() => {
  store.commit('setFullCard', false)
  if(props.object && !props.object.id) {
    store.commit('setFormTabActive', newPatientViews[0])
  }
  if(props.object && props.object.id) {
    store.commit('setFormTabActive', views[0])
  }
})

const tabChanged = (tab) => {
  store.commit('setFormTabActive', newPatientViews[tab])
}

const tabSelected = (tab) => {
  store.commit('setFormTabActive', views[tab])
}

watch(representativePerson, (val) => {
  if(val) {
    const object = props.object
    object.representative_fio = val.full_name
    if(!rights.value.includes('hide_patient_phone')) {
      object.representative_phone = val.phone
    }
    object.representative_address = val.address
    object.representative_passport = val.passport
    const additional = val.user_additional || {}

    object.representative_document_type_id = val.document_type_id
    object.representative_passport_series = val.passport_series
    object.representative_passport_data =  val.passport
    object.representative_date_of_birth =  val.date_of_birth
    object.representative_passport_issue_date = val.passport_issue_date
    object.representative_passport_dep_code = val.passport_dep_code
    object.representative_passport_given_by = val.passport_given_by
    object.representative_snils = val.snils
    object.representative_inn = val.taxcode
    object.representative_region_egisz_id = additional.region_egisz_id
    object.representative_zip_code = additional.zip_code
    object.representative_gender = val.gender
  }
})
</script>
